import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from "@angular/forms";
import moment from "moment";
import { MasterService } from "src/app/services/master.service";
import { MessageService } from "src/app/services/message.service";
import * as languageLibrary from "../../services/language";
import { TAX_METHODS } from "src/app/constants/sale";
import { ReceiptLine } from "src/app/models/receipt-line.model";

@Component({
    selector: "app-deals",
    templateUrl: "./deals.component.html",
    styleUrls: ["./deals.component.scss"],
    standalone: false
})
export class DealsComponent implements OnInit {
  protected origination = new FormGroup({
    saleDate: new FormControl<string>("2022-05-23", [Validators.required]),
    firstScheduledPaymentDueDate: new FormControl<string>("2022-06-23", [
      Validators.required,
    ]),
    salePrice: new FormControl<number>(15000, []),
    apr: new FormControl<number>(40, [Validators.required]),
    subjectToFinance: new FormControl<number>(16173.77, []),
    scheduledPaymentAmount: new FormControl<number>(0, [Validators.required]),
    numberOfPayments: new FormControl<number>(12, [Validators.required]),
    taxRate: new FormControl<number>(0.0625, []),
    paymentCycle: new FormControl<string>("Monthly", []),
    zipCode: new FormControl<number>(77080, []),
    modelYear: new FormControl<number>(2007, []),
    lotId: new FormControl<number>(5, []),
    changedField: new FormControl<number>(0, []),
    finalOddLastPayment: new FormControl<number>(0, []),
    excludeAmort: new FormControl<number>(0, []),
    tradeInAllowance: new FormControl<number>(0, []),
    taxMethod: new FormControl<string>("DEFERRED", []),
    financingTypeId: new FormControl<string>("BHPH", []),
    totalDown: new FormControl<number>(0, []),
  });
  protected terms = new FormGroup({
    taxRatio: new FormControl<number>(0),
    dailyAPR: new FormControl<number>(0),
    platform: new FormControl<string | null>(null),
    chargeLateFees: new FormControl<boolean>(false),
  });
  protected paymentParameters = new FormGroup({
    dealer: new FormControl<number>(5),
    lot: new FormControl<number>(5),
    term: new FormControl<number>(2),
    contact: new FormControl<number>(68186),
  });

  protected paymentInformation = null;
  protected realTimeAmortization = null;
  protected words = languageLibrary.language;
  protected schedule = [];
  protected scheduleTotals = null;
  @Input() language: string = "EN";
  protected calculating: boolean = false;
  protected initialize: boolean;
  //  An associative array of sale tax methods with the id as the key
  protected taxMethods: Object = TAX_METHODS;
  protected demoTransaction = [
    { amountPaid: 500, datePaid: "2022-07-01", transactionId: 1 },
    { amountPaid: 500, datePaid: "2022-07-15", transactionId: 2 },
    { amountPaid: 1000, datePaid: "2022-08-01", transactionId: 3 },
    { amountPaid: 2887.12, datePaid: "2022-08-23", transactionId: 4 },
    // { amountPaid: 500, datePaid: "2022-10-23", transactionId: 4 },
    // { amountPaid: 200, datePaid: "2022-10-30", transactionId: 5 },
    // { amountPaid: 500, datePaid: "2022-11-23", transactionId: 6 },
    // { amountPaid: 500, datePaid: "2022-12-23", transactionId: 7 },
    // { amountPaid: 600, datePaid: "2023-01-23", transactionId: 8 },
    // { amountPaid: 12000, datePaid: "2023-02-23", transactionId: 9 },
    // { amountPaid: 200, datePaid: "2023-03-23", transactionId: 10 },
    // { amountPaid: 200, datePaid: "2023-04-23", transactionId: 11 },
    // { amountPaid: 500, datePaid: "2023-05-23", transactionId: 12 },
    // { amountPaid: 500, datePaid: "2023-06-23", transactionId: 13 },
    // { amountPaid: 500, datePaid: "2023-07-23", transactionId: 14 },
    // { amountPaid: 500, datePaid: "2023-08-23", transactionId: 15 },
    // { amountPaid: 500, datePaid: "2023-09-23", transactionId: 16 },
    // { amountPaid: 2000, datePaid: "2023-10-23", transactionId: 17 },
    // { amountPaid: 836.55, datePaid: "2023-11-01", transactionId: 18 },
  ];
  protected transactionBreakdown = [];
  protected transactionBreakdown2 = [];
  protected transactionBreakDownNumber = 0;
  protected transactionBreakDownNumber2 = 0;
  protected sumOfPrincipalPaid = 0;
  protected sumOfTaxPaid = 0;
  protected sumOfTaxPaidToComptroller = 0;
  protected sumOfInterestPaid = 0;
  protected currentPayoff = 0;
  protected initialPayoff = 0;
  protected initialUnpaidBalance: number = 0;
  protected currentUnpaidBalance: number = 0;
  protected downPayment = null
  protected downPaymentSums: {};
  protected sumOfAmountPaid: number = 0;
  protected sumOfLateFeesPaid = 0;
  protected realScheduledPayments = []
  protected realActualPayments = []
  protected updatedPaymentSchedule = []
  private realPaymentFees: any;
  protected lines: ReceiptLine[] = []

  get taxMethodKeys() {
    return Object.keys(this.taxMethods);
  }

  constructor(
    private master: MasterService,
    private ms: MessageService,
    private fb: FormBuilder
  ) { 
    this.paymentInformation = this.fb.group({
      transactions: this.fb.array([]),
    });

    this.realTimeAmortization = this.fb.group({
      scheduledPayments: this.fb.array([]),
    });

    this.downPayment = this.fb.group({
      downPayments: this.fb.array([]),
    });
  }

  /**
   * Helper method to consistently get the list of form methods as an Array.
   */
  get transactions() {
    return this.paymentInformation.controls["transactions"] as FormArray;
  }
  get scheduledPayments() {
    return this.realTimeAmortization.controls["scheduledPayments"] as FormArray;
  }
  get downPayments() {
    return this.downPayment.controls["downPayments"] as FormArray;
  }
  get taxRatio() {
    return this.terms.get("taxRatio").value;
  }
  get platform() {
    return this.terms.get("platform").value;
  }
  get chargeLateFees() {
    return this.terms.get("chargeLateFees").value;
  }

  ngOnInit() {
    
  }

  protected calculate(e): void {
    if (this.calculating) {
      return;
    }

    let changedField = e.target.id;

    if (changedField == "saleDate" || changedField == "paymentCycle") {
      this.setFirstScheduledPaymentDueDate();
    }

    if (this.origination.get("salePrice").value == 0) {
      return;
    }

    if (this.origination.pristine) {
      return;
    }

    if (
      !this.origination.get("numberOfPayments").value &&
      !this.origination.get("scheduledPaymentAmount").value
    ) {
      return;
    }

    this.schedule = [];
    this.scheduleTotals = null;
    this.origination.patchValue({ changedField: changedField });

    if (
      changedField == "apr" ||
      changedField == "firstScheduledPaymentDueDate" ||
      changedField == "numberOfPayments" ||
      changedField == "subjectToFinance" ||
      changedField == "paymentCycle" ||
      changedField == "saleDate" ||
      changedField == "taxRate" ||
      changedField == "modelYear" ||
      changedField == "excludeAmort" ||
      changedField == "tradeInAllowance" ||
      changedField == "taxMethod"
    ) {
      this.origination.patchValue({ scheduledPaymentAmount: 0 });
    }
    if (
      changedField == "scheduledPaymentAmount" ||
      changedField == "salePrice"
    ) {
      this.origination.patchValue({ numberOfPayments: 0 });
    }
    if (changedField == "salePrice") {
      this.origination.patchValue({ subjectToFinance: 0 });
    }
    if (changedField == "saleDate") {
      this.origination.patchValue({ modelYear: 0 });
      this.setFirstScheduledPaymentDueDate();
    }

    if (
      (!this.origination.get("numberOfPayments").value &&
        !this.origination.get("scheduledPaymentAmount").value) ||
      !this.origination.get("subjectToFinance").value ||
      !this.origination.get("modelYear").value
    ) {
      return;
    }

    let payload = this.origination.value;

    this.origination.markAsPristine();
    this.calculating = true;
    this.master.patch(`engine`, { term: payload }, (res) => {
      this.calculating = false;
      if (!res) {
        this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]["apiNoResponse"], });
        return;
      }

      if (res.status !== 200) {
        this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
        return;
      }

      this.schedule = res.data.result.schedule;

      this.buildScheduledPayment(this.schedule);
      this.scheduleTotals = res.data.result.scheduleTotals;
      if (!this.scheduleTotals) {
        return;
      }
      this.origination.patchValue({
        apr: this.scheduleTotals.apr * 100,
        numberOfPayments: this.scheduleTotals.numberOfPayments,
        scheduledPaymentAmount: parseFloat(
          this.scheduleTotals.scheduledPaymentAmount
        ),
        finalOddLastPayment: this.scheduleTotals.finalOddLastPayment,
      });
      this.terms.patchValue({
        taxRatio:
          this.scheduleTotals.totalPaymentTax /
          this.scheduleTotals.totalPayments,
        dailyAPR: this.scheduleTotals.dailyAPR
      });
      this.initialPayoff =
        this.scheduleTotals.totalPayments - this.scheduleTotals.financeCharges + this.origination.get('totalDown').value;
    });
  }

  protected setFirstScheduledPaymentDueDate() {
    let firstDueDate = null;
    let paymentCycle = this.origination.get("paymentCycle").value;
    let saleDate = this.origination.get("saleDate").value;
    switch (paymentCycle.toLowerCase()) {
      case "weekly": // once a week
        firstDueDate = moment(saleDate).add(1, "week").format("yyyy-MM-DD");
        break;
      case "bi-weekly": // every two weeks
      case "biweekly":
        firstDueDate = moment(saleDate).add(2, "weeks").format("yyyy-MM-DD");
        break;
      case "semi-monthly": // twice a month
      case "semimonthly":
        firstDueDate = moment(saleDate).add(15, "days").format("yyyy-MM-DD");
        break;
      case "bi-monthly": // every two months
        firstDueDate = moment(saleDate).add(2, "months").format("yyyy-MM-DD");
        break;
      case "quaterly": // every three months
        firstDueDate = moment(saleDate).add(3, "months").format("yyyy-MM-DD");
        break;
      case "annually":
        firstDueDate = moment(saleDate).add(1, "year").format("yyyy-MM-DD");
        break;
      default: // once a month (i.e. monthly)
        firstDueDate = moment(saleDate).add(1, "month").format("yyyy-MM-DD");
        break;
    }

    if (!firstDueDate) {
      // no change?
      return;
    }
    this.origination.patchValue({ firstScheduledPaymentDueDate: firstDueDate });
  }

  /**
   * addTransaction
   */
  protected addTransaction = (): void => {
    const transaction = this.fb.group({
      amountPaid: [null, [Validators.required]],
      datePaid: [null, [Validators.required]],
      principalDue: [0, [Validators.required]],
      interestDue: [0, [Validators.required]],
      taxDue: [0, [Validators.required]],
      transactionId: [
        this.transactions.length == 0 ? 1 : this.transactions.length + 1,
        [Validators.required],
      ],
      payoffAfterPayment: [0, [Validators.required]],
      unpaidPrincipalBalanceAfterPayment: [0, [Validators.required]],
      taxableToState: [0, [Validators.required]],
      lateFeesDue: [0, [Validators.required]],
    });

    this.transactions.push(transaction);
  };
  /**
   * removeTransaction
   */
  protected removeTransaction = (i): void => {
    this.transactions.removeAt(i);
  };
  /**
   * removeTransaction
   */
  protected removeDownPayment = (i): void => {
    this.downPayments.removeAt(i);
  };

  protected clearTransactionBreakdown() {
    this.transactionBreakdown = [];
    this.transactionBreakDownNumber = 1
  }
  protected clearTransactions() {
    this.transactions.clear();
  }

  /**
   * calculateBuckets
   */
  protected calculateBuckets() {
    this.buildPayments();
    this.sumOfPrincipalPaid = 0;
    this.sumOfTaxPaid = 0;
    this.sumOfInterestPaid = 0;
    this.sumOfAmountPaid = 0;
    this.sumOfLateFeesPaid = 0;

    const calcStatus = (amountDue, sPmt, dPaid, dDue) => {
      let status = "Unpaid"
      if (amountDue == 0) {
        status = "Fully Paid"
      } else {
        if (amountDue != sPmt) {
          status = "Partially Paid"
          if (moment(dPaid).isBefore(dDue)) {
            status = "Prepaid"
          }
        }
      }
      return status
    }

    for (let index = 0; index < this.transactions.value.length; index++) {
      const transaction = this.transactions.value[index];
      let amtPaid = transaction["amountPaid"];
      this.sumOfAmountPaid += parseFloat(amtPaid)
      let totalToAllocate = amtPaid;
      let datePaid = transaction["datePaid"];
      let lateFeesPaid = 0
      let lateFeesAccrued = 0

      let paymentsDue = this.scheduledPayments.value.filter((res) =>
        moment(res.dueDate).isSameOrBefore(datePaid)
      );

      // Set late fees
      if (this.chargeLateFees) {
        let lateFee = 0
        for (let index7 = 0; index7 < paymentsDue.length; index7++) {
          const element = paymentsDue[index7];
          const daysLate = moment(datePaid).diff(element.dueDate, 'days')
          let amountDueExcludingLateFee = parseFloat(Math.fround(element.amountDue).toFixed(2)) - parseFloat(Math.fround(element.lateFee).toFixed(2))
          if (daysLate > 0 && amountDueExcludingLateFee > 0) {
            paymentsDue[index7].daysLate = daysLate
          }
          if (daysLate >= 16 && amountDueExcludingLateFee > 0 && element.lateFeeOriginal == 0) {
            console.log(element.dueDate)
            lateFee = (element.scheduledPaymentAmount * 0.05)
            paymentsDue[index7].lateFee = lateFee
            paymentsDue[index7].lateFeeOriginal = lateFee
            paymentsDue[index7].amountDue = parseFloat(paymentsDue[index7].amountDue) + lateFee
          }
        }
      }

      // Distribute to initial down payment tax, if any
      let taxDPDue = paymentsDue.length > 0
        ? paymentsDue.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue.taxAmountForDPayment),
          0
        )
        : 0;

      let allocate = parseFloat(Math.fround(taxDPDue).toFixed(2)) > parseFloat(Math.fround(totalToAllocate).toFixed(2)) ? parseFloat(Math.fround(totalToAllocate).toFixed(2)) : parseFloat(Math.fround(taxDPDue).toFixed(2));
      let taxPaid = 0;
      let taxPaidLine = 0;
      if (allocate > 0 && taxDPDue > 0) {
        for (let index5 = 0; index5 < this.scheduledPayments.length; index5++) {
          const scheduledPmt = this.scheduledPayments.controls[index5].value;
          if (!scheduledPmt["type"].includes("Down Payment") && !moment(scheduledPmt.dueDate).isSameOrBefore(datePaid)) {
            continue
          }
          if (scheduledPmt.taxAmountForDPayment > 0) {
            if (allocate >= parseFloat(Math.fround(scheduledPmt.taxAmountForDPayment).toFixed(2))) {
              allocate = !scheduledPmt.initial ? parseFloat(Math.fround(allocate).toFixed(2)) - parseFloat(Math.fround(scheduledPmt.taxAmountForDPayment).toFixed(2)) : totalToAllocate;
              taxPaid += parseFloat(Math.fround(scheduledPmt.taxAmountForDPayment).toFixed(2));
              taxPaidLine = parseFloat(Math.fround(scheduledPmt.taxAmountForDPayment).toFixed(2));
              scheduledPmt.taxAmountForDPayment = 0;
            } else {
              scheduledPmt.taxAmountForDPayment = parseFloat(Math.fround(scheduledPmt.taxAmountForDPayment).toFixed(2)) - parseFloat(Math.fround(allocate).toFixed(2))
              taxPaid += parseFloat(Math.fround(allocate).toFixed(2));
              taxPaidLine = parseFloat(Math.fround(allocate).toFixed(2));
              allocate -= !scheduledPmt.initial ? parseFloat(Math.fround(allocate).toFixed(2)) : 0;
            }
            if (taxPaidLine > 0) {
              this.sumOfTaxPaid = this.sumOfTaxPaid + taxPaidLine;
              this.buildTransactionBreakdown({
                amtPaid,
                transactionId: transaction.transactionId,
                taxPaid: taxPaidLine,
                paymentId: scheduledPmt.number,
                dueDate: scheduledPmt.dueDate,
                scheduledPaymentAmount: scheduledPmt.scheduledPaymentAmount,
              });
              totalToAllocate = !scheduledPmt.initial ? Math.abs(totalToAllocate - taxPaidLine) : totalToAllocate;
            }
            this.transactions.controls[index].patchValue({
              taxDue: taxPaidLine,
              taxableToState: taxPaidLine
            });
            if (taxPaid == taxDPDue) {
              break;
            }
          }
        }
      }

      if (this.chargeLateFees) {
        let lateFeesAccrued =
          paymentsDue.length > 0
            ? paymentsDue.reduce(
              (accumulator, currentValue) =>
                accumulator + parseFloat(currentValue.lateFee),
              0
            )
            : 0;
        allocate = parseFloat(Math.fround(lateFeesAccrued).toFixed(2)) > parseFloat(Math.fround(totalToAllocate).toFixed(2)) ? parseFloat(Math.fround(totalToAllocate).toFixed(2)) : parseFloat(Math.fround(lateFeesAccrued).toFixed(2))

        this.transactions.controls[index].patchValue({
          lateFeesDue: allocate,
        });
        let lateFeesPaidLine = 0
        if (allocate > 0 && lateFeesAccrued > 0) {
          if (lateFeesAccrued > 0) {
            for (let index6 = 0; index6 < paymentsDue.length; index6++) {
              const scheduledPmt = paymentsDue[index6];
              if (scheduledPmt.lateFee > 0) {
                if (allocate >= parseFloat(Math.fround(scheduledPmt.lateFee).toFixed(2))) {
                  allocate = parseFloat(Math.fround(allocate).toFixed(2)) - parseFloat(Math.fround(scheduledPmt.lateFee).toFixed(2));
                  lateFeesPaid += parseFloat(Math.fround(scheduledPmt.lateFee).toFixed(2));
                  lateFeesPaidLine = parseFloat(Math.fround(scheduledPmt.lateFee).toFixed(2));
                  scheduledPmt.lateFee = 0;
                } else {
                  scheduledPmt.lateFee =
                    parseFloat(Math.fround(scheduledPmt.lateFee).toFixed(2)) - parseFloat(Math.fround(allocate).toFixed(2));
                  lateFeesPaid += parseFloat(Math.fround(allocate).toFixed(2));
                  lateFeesPaidLine = parseFloat(Math.fround(allocate).toFixed(2));
                  allocate -= parseFloat(Math.fround(allocate).toFixed(2));
                }
                if (lateFeesPaidLine > 0) {
                  scheduledPmt.amountDue -= lateFeesPaidLine;
                  this.sumOfLateFeesPaid = this.sumOfLateFeesPaid + lateFeesPaidLine;
                  this.buildTransactionBreakdown({
                    transactionId: transaction.transactionId,
                    lateFee: lateFeesPaidLine,
                    paymentId: scheduledPmt.number,
                    dueDate: scheduledPmt.dueDate,
                    scheduledPaymentAmount: scheduledPmt.scheduledPaymentAmount,
                    initial: scheduledPmt.initial
                  });
                }
                if (lateFeesPaid == lateFeesAccrued && allocate == 0) {
                  break;
                }
              }
            }
          }
        }
        totalToAllocate = Math.abs(totalToAllocate - lateFeesPaid);
      }
      // Distribute to tax, if any
      let taxDue = taxDPDue == 0 ? parseFloat(Math.fround((amtPaid - lateFeesPaid) * this.taxRatio).toFixed(2)) : 0;
      allocate = parseFloat(Math.fround(taxDue).toFixed(2)) > parseFloat(Math.fround(totalToAllocate).toFixed(2)) ? parseFloat(Math.fround(totalToAllocate).toFixed(2)) : parseFloat(Math.fround(taxDue).toFixed(2));
      taxPaid = 0;
      taxPaidLine = 0;
      if (allocate > 0 && taxDue > 0) {
        for (let index2 = 0; index2 < this.scheduledPayments.length; index2++) {
          const scheduledPmt = this.scheduledPayments.controls[index2].value;
          if (scheduledPmt["type"].includes("Down Payment") && !moment(scheduledPmt.dueDate).isSameOrBefore(datePaid)) {
            continue
          }
          if (scheduledPmt.taxAmountForPayment > 0) {
            if (allocate >= parseFloat(Math.fround(scheduledPmt.taxAmountForPayment).toFixed(2))) {
              allocate = !scheduledPmt.initial ? parseFloat(Math.fround(allocate).toFixed(2)) - parseFloat(Math.fround(scheduledPmt.taxAmountForPayment).toFixed(2)) : parseFloat(Math.fround(totalToAllocate).toFixed(2));
              taxPaid += parseFloat(Math.fround(scheduledPmt.taxAmountForPayment).toFixed(2));
              taxPaidLine = parseFloat(Math.fround(scheduledPmt.taxAmountForPayment).toFixed(2));
              scheduledPmt.taxAmountForPayment = 0;
            } else {
              scheduledPmt.taxAmountForPayment = parseFloat(Math.fround(scheduledPmt.taxAmountForPayment).toFixed(2)) - parseFloat(Math.fround(allocate).toFixed(2))
              taxPaid += parseFloat(Math.fround(allocate).toFixed(2));
              taxPaidLine = parseFloat(Math.fround(allocate).toFixed(2));
              allocate -= !scheduledPmt.initial ? parseFloat(Math.fround(allocate).toFixed(2)) : 0;
            }
            if (taxPaidLine > 0) {
              scheduledPmt.amountDue -= taxPaidLine;
              this.sumOfTaxPaid = this.sumOfTaxPaid + taxPaidLine;
              this.buildTransactionBreakdown({
                amtPaid,
                transactionId: transaction.transactionId,
                taxPaid: taxPaidLine,
                paymentId: scheduledPmt.number,
                dueDate: scheduledPmt.dueDate,
                scheduledPaymentAmount: scheduledPmt.scheduledPaymentAmount,
                initial: scheduledPmt.initial
              });
              totalToAllocate = !scheduledPmt.initial ? Math.abs(totalToAllocate - taxPaidLine) : totalToAllocate;
            }
            this.transactions.controls[index].patchValue({
              taxDue,
              taxableToState: taxDue
            });
            scheduledPmt.status = calcStatus(scheduledPmt.amountDue, scheduledPmt.scheduledPaymentAmount, datePaid, scheduledPmt.dueDate)
            if (taxPaid == taxDue) {
              break;
            }
          }
        }
      }

      // Distribute to interest, if any  //scheduled installment
      let interestAccrued =
        paymentsDue.length > 0
          ? paymentsDue.reduce(
            (accumulator, currentValue) =>
              accumulator + parseFloat(currentValue.interestAmount),
            0
          )
          : 0;
      let interestBeenPaid =
        paymentsDue.length > 0
          ? paymentsDue.reduce(
            (accumulator, currentValue) =>
              accumulator + parseFloat(currentValue.originalInterestAmount),
            0
          )
          : 0;
      // true daily interestAccrued = dailyAPR * amtPaid
      allocate = amtPaid > 0 ? parseFloat(Math.fround(interestAccrued).toFixed(2)) > parseFloat(Math.fround(totalToAllocate).toFixed(2)) ? parseFloat(Math.fround(totalToAllocate).toFixed(2)) : parseFloat(Math.fround(interestAccrued).toFixed(2)) :
        parseFloat(Math.fround(interestBeenPaid).toFixed(2)) > parseFloat(Math.fround(totalToAllocate).toFixed(2)) ? parseFloat(Math.fround(totalToAllocate).toFixed(2)) : parseFloat(Math.fround(interestBeenPaid).toFixed(2));

      this.transactions.controls[index].patchValue({
        interestDue: allocate,
      });
      let interestPaid = 0;
      let interestPaidLine = 0;
      if (allocate > 0 && interestAccrued > 0) {
        if (interestAccrued > 0) {
          for (let index3 = 0; index3 < paymentsDue.length; index3++) {
            const scheduledPmt = paymentsDue[index3];
            // if (scheduledPmt["type"].includes("Down Payment")) {
            //   continue
            // }
            if (scheduledPmt.interestAmount > 0) {
              if (allocate >= parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2))) {
                allocate = parseFloat(Math.fround(allocate).toFixed(2)) - parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2));
                interestPaid += parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2));
                interestPaidLine = parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2));
                scheduledPmt.interestAmount = 0;
              } else {
                scheduledPmt.interestAmount =
                  parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2)) - parseFloat(Math.fround(allocate).toFixed(2));
                interestPaid += parseFloat(Math.fround(allocate).toFixed(2));
                interestPaidLine = parseFloat(Math.fround(allocate).toFixed(2));
                allocate -= parseFloat(Math.fround(allocate).toFixed(2));
              }
              if (interestPaidLine > 0) {
                scheduledPmt.amountDue -= interestPaidLine;
                this.sumOfInterestPaid =
                  this.sumOfInterestPaid + interestPaidLine;
                this.buildTransactionBreakdown({
                  transactionId: transaction.transactionId,
                  interestPaid: interestPaidLine,
                  paymentId: scheduledPmt.number,
                  dueDate: scheduledPmt.dueDate,
                  scheduledPaymentAmount: scheduledPmt.scheduledPaymentAmount,
                  initial: scheduledPmt.initial
                });
              }
              scheduledPmt.status = calcStatus(scheduledPmt.amountDue, scheduledPmt.scheduledPaymentAmount, datePaid, scheduledPmt.dueDate)
              if (interestPaid == interestAccrued && allocate == 0) {
                break;
              }
            }
          }
        }
      }
      totalToAllocate = Math.abs(totalToAllocate - interestPaidLine);

      // Distribute to principal, if any
      let principalDue =
        amtPaid - taxDue - interestAccrued - lateFeesAccrued > 0
          ? amtPaid - taxDue - interestAccrued - lateFeesAccrued
          : 0;
      if (principalDue > this.currentUnpaidBalance) {
        this.currentUnpaidBalance = this.currentUnpaidBalance + (this.scheduleTotals.totalTax - this.sumOfTaxPaid)
        taxPaid = (this.scheduleTotals.totalTax - this.sumOfTaxPaid) + taxDue
        this.transactions.controls[index].patchValue({
          taxDue: parseFloat(Math.fround(taxPaid).toFixed(2)),
          taxableToState: parseFloat(Math.fround(taxPaid).toFixed(2))
        });
        this.sumOfTaxPaid = this.sumOfTaxPaid + taxPaid - taxPaidLine;
        this.sumOfTaxPaidToComptroller = this.sumOfTaxPaid
        paymentsDue.forEach(res => {
          res.taxAmountForPayment = 0
          res.principalPaid = 0
          res.amountDue = 0
        });
        principalDue =
          amtPaid - taxPaid - interestPaidLine > 0
            ? amtPaid - taxPaid - interestPaidLine
            : 0;
      }
      this.currentPayoff = amtPaid < parseFloat(Math.fround(this.currentPayoff).toFixed(2)) ? this.currentPayoff - principalDue - taxDue : 0;
      this.currentUnpaidBalance = parseFloat(Math.fround(this.currentPayoff).toFixed(2)) > 0 ? this.currentUnpaidBalance - principalDue + taxDPDue : 0;
      allocate = parseFloat(Math.fround(principalDue).toFixed(2)) > parseFloat(Math.fround(totalToAllocate).toFixed(2)) ? parseFloat(Math.fround(totalToAllocate).toFixed(2)) : parseFloat(Math.fround(principalDue).toFixed(2));
      this.transactions.controls[index].patchValue({
        principalDue: allocate,
        payoffAfterPayment: parseFloat(
          Math.fround(this.currentPayoff).toFixed(2)
        ),
        unpaidPrincipalBalanceAfterPayment: parseFloat(Math.fround(this.currentUnpaidBalance).toFixed(3)) <= 0 ? 0 : parseFloat(Math.fround(this.currentUnpaidBalance).toFixed(2)),
      });
      if (allocate > 0 && principalDue > 0) {
        let principalPaidLine = 0;
        let principalPaid = 0;
        for (let index4 = 0; index4 < this.scheduledPayments.length; index4++) {
          const scheduledPmt = this.scheduledPayments.controls[index4].value;
          if (scheduledPmt.principalPaid > 0) {
            if (allocate >= parseFloat(Math.fround(scheduledPmt.principalPaid).toFixed(2))) {
              allocate = parseFloat(Math.fround(allocate).toFixed(2)) - parseFloat(Math.fround(scheduledPmt.principalPaid).toFixed(2));
              console.log(`${parseFloat(Math.fround(allocate).toFixed(2))} - ${parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2))}`)
              principalPaid += parseFloat(Math.fround(scheduledPmt.principalPaid).toFixed(2));
              principalPaidLine = parseFloat(Math.fround(scheduledPmt.principalPaid).toFixed(2));
              scheduledPmt.principalPaid = 0;
            } else {
              scheduledPmt.principalPaid =
                parseFloat(Math.fround(scheduledPmt.principalPaid).toFixed(2)) - parseFloat(Math.fround(allocate).toFixed(2));
              principalPaid += parseFloat(Math.fround(allocate).toFixed(2));
              principalPaidLine = parseFloat(Math.fround(allocate).toFixed(2));
              allocate -= parseFloat(Math.fround(allocate).toFixed(2))
            }
            if (parseFloat(Math.fround(allocate).toFixed(2)) == 0.01) {
              principalPaid += 0.01
              principalPaidLine += parseFloat(Math.fround(scheduledPmt.principalPaid).toFixed(2)) + 0.01
              allocate -= parseFloat(Math.fround(allocate).toFixed(2));
            }
            if (principalPaidLine > 0) {
              scheduledPmt.amountDue -= principalPaidLine;
              this.sumOfPrincipalPaid =
                this.sumOfPrincipalPaid + parseFloat(Math.fround(principalPaidLine).toFixed(2));
              this.buildTransactionBreakdown({
                transactionId: transaction.transactionId,
                principalPaid: principalPaidLine,
                paymentId: scheduledPmt.number,
                dueDate: scheduledPmt.dueDate,
                scheduledPaymentAmount: scheduledPmt.scheduledPaymentAmount,
                initial: scheduledPmt.initial
              });
            }
            // if (scheduledPmt.amountDue == 0){
            //   scheduledPmt.lateFee = 0
            // }
            totalToAllocate = Math.abs(totalToAllocate - principalPaidLine);
            if (principalPaid == principalDue && allocate == 0) {
              break;
            }
          }
          scheduledPmt.status = calcStatus(scheduledPmt.amountDue, scheduledPmt.scheduledPaymentAmount, datePaid, scheduledPmt.dueDate)
        }
      }
    }
  }

  protected calculateBucketsAPI = async () => {
    this.buildPayments();
    this.sumOfPrincipalPaid = 0;
    this.sumOfTaxPaid = 0;
    this.sumOfInterestPaid = 0;
    this.sumOfAmountPaid = 0;
    this.sumOfLateFeesPaid = 0;
    let prevDatePaid = null

    for (let index = 0; index < this.transactions.value.length; index++) {
      let payload = {}
      const transaction = this.transactions.value[index];
      let amtPaid = transaction["amountPaid"];
      this.sumOfAmountPaid += amtPaid;
      let datePaid = transaction["datePaid"];
      payload['amountPaidByBucket'] = { "loan": amtPaid }
      payload['collectionMethod'] = "Scheduled Installment Earnings"
      payload['payoffBalance'] = this.currentPayoff
      payload['principalBalance'] = this.currentUnpaidBalance
      payload['dailyAPR'] = this.terms.get('dailyAPR').value
      payload['taxRatio'] = this.terms.get('taxRatio').value

      let paymentsDue = this.scheduledPayments.value.filter((res) =>
        moment(res.dueDate).isSameOrBefore(datePaid)
      );

      // Distribute to tax, if any
      // Distribute to interest, if any  //scheduled installment
      let interestAccrued =
        paymentsDue.length > 0
          ? paymentsDue.reduce(
            (accumulator, currentValue) =>
              accumulator + parseFloat(currentValue.interestAmount),
            0
          )
          : 0;

      payload['accruedInterest'] = interestAccrued
      payload['amountPaid'] = amtPaid
      payload['datePaid'] = datePaid
      payload['previousPaymentDate'] = prevDatePaid
      payload['orderOfAllocation'] = [
        "tax",
        "interest",
        "principal"
      ]

      await this.master.postAsync(`paymentAllocation`, payload).then(async (res) => {
        if (!res) {
          this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]["apiNoResponse"], });
          return;
        }

        if (res.status !== 200) {
          this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
          return;
        }

        let result = res.data.result;

        this.transactions.controls[index].patchValue({
          interestDue: result['allocated_interest'],
          taxDue: result['allocated_tax'],
          principalDue: result['allocated_principal'],
          payoffAfterPayment: result['payoffBalance'],
          unpaidPrincipalBalanceAfterPayment: result['principalBalance'],
        });
        this.currentPayoff = result['payoffBalance'];
        this.currentUnpaidBalance = result['principalBalance'];

        let taxPaid = 0
        let taxPaidLine = 0
        let interestPaid = 0
        let interestPaidLine = 0
        let principalPaid = 0
        let principalPaidLine = 0
        for (let index = 0; index < paymentsDue.length; index++) {
          const scheduledPmt = paymentsDue[index];
          if (scheduledPmt.taxAmountForPayment > 0) {
            if (result['allocated_tax'] >= parseFloat(Math.fround(scheduledPmt.taxAmountForPayment).toFixed(2))) {
              taxPaid += parseFloat(Math.fround(scheduledPmt.taxAmountForPayment).toFixed(2));
              taxPaidLine = parseFloat(Math.fround(scheduledPmt.taxAmountForPayment).toFixed(2));
              scheduledPmt.taxAmountForPayment = 0;
            } else {
              scheduledPmt.taxAmountForPayment = parseFloat(Math.fround(scheduledPmt.taxAmountForPayment).toFixed(2)) - parseFloat(Math.fround(result['allocated_tax']).toFixed(2))
              taxPaid += parseFloat(Math.fround(result['allocated_tax']).toFixed(2));
              taxPaidLine = parseFloat(Math.fround(result['allocated_tax']).toFixed(2));
            }
            if (taxPaidLine > 0) {
              scheduledPmt.amountDue -= taxPaidLine;
              this.sumOfTaxPaid = this.sumOfTaxPaid + taxPaidLine;
              this.buildTransactionBreakdown({
                amtPaid,
                transactionId: transaction.transactionId,
                taxPaid: taxPaidLine,
                paymentId: scheduledPmt.number,
                dueDate: scheduledPmt.dueDate,
                scheduledPaymentAmount: scheduledPmt.scheduledPaymentAmount,
                initial: scheduledPmt.initial
              });
            }
          }
          if (scheduledPmt.interestAmount > 0) {
            if (result['allocated_interest'] >= parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2))) {
              interestPaid += parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2));
              interestPaidLine = parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2));
              scheduledPmt.interestAmount = 0;
            } else {
              scheduledPmt.interestAmount =
                parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2)) - parseFloat(Math.fround(result['allocated_interest']).toFixed(2));
              interestPaid += parseFloat(Math.fround(result['allocated_interest']).toFixed(2));
              interestPaidLine = parseFloat(Math.fround(result['allocated_interest']).toFixed(2));
            }
            if (interestPaidLine > 0) {
              scheduledPmt.amountDue -= interestPaidLine;
              this.sumOfInterestPaid =
                this.sumOfInterestPaid + interestPaidLine;
              this.buildTransactionBreakdown({
                transactionId: transaction.transactionId,
                interestPaid: interestPaidLine,
                paymentId: scheduledPmt.number,
                dueDate: scheduledPmt.dueDate,
                scheduledPaymentAmount: scheduledPmt.scheduledPaymentAmount,
                initial: scheduledPmt.initial
              });
            }
          }
          if (scheduledPmt.principalPaid > 0) {
            if (result['allocated_principal'] >= parseFloat(Math.fround(scheduledPmt.principalPaid).toFixed(2))) {
              console.log(`${parseFloat(Math.fround(result['allocated_principal']).toFixed(2))} - ${parseFloat(Math.fround(scheduledPmt.interestAmount).toFixed(2))}`)
              principalPaid += parseFloat(Math.fround(scheduledPmt.principalPaid).toFixed(2));
              principalPaidLine = parseFloat(Math.fround(scheduledPmt.principalPaid).toFixed(2));
              scheduledPmt.principalPaid = 0;
            } else {
              scheduledPmt.principalPaid =
                parseFloat(Math.fround(scheduledPmt.principalPaid).toFixed(2)) - parseFloat(Math.fround(result['allocated_principal']).toFixed(2));
              principalPaid += parseFloat(Math.fround(result['allocated_principal']).toFixed(2));
              principalPaidLine = parseFloat(Math.fround(result['allocated_principal']).toFixed(2));
            }
            if (principalPaidLine > 0) {
              scheduledPmt.amountDue -= principalPaidLine;
              this.sumOfPrincipalPaid =
                this.sumOfPrincipalPaid + parseFloat(Math.fround(principalPaidLine).toFixed(2));
              this.buildTransactionBreakdown({
                transactionId: transaction.transactionId,
                principalPaid: principalPaidLine,
                paymentId: scheduledPmt.number,
                dueDate: scheduledPmt.dueDate,
                scheduledPaymentAmount: scheduledPmt.scheduledPaymentAmount,
                initial: scheduledPmt.initial
              });
            }
          }
        }

      })
      prevDatePaid = datePaid
    }
  }

  protected buildScheduledPayment(schedule: any[]) {
    for (let index = 0; index < this.downPayments.length; index++) {
      const element = this.downPayments.value[index];
      const dPmt = this.fb.group({
        type: element.initial ? "Initial Down Payment" : "Deferred Down Payment",
        number: element.number,
        dueDate: moment(element.dueDate).format("MM/DD/YYYY"),
        scheduledPaymentAmount: element.scheduledPaymentAmount,
        amountDue: element.scheduledPaymentAmount,
        principalPaid: parseFloat(Math.fround(element.scheduledPaymentAmount).toFixed(2)), // : parseFloat(Math.fround(element.scheduledPaymentAmount).toFixed(2)) - (parseFloat(Math.fround(element.scheduledPaymentAmount).toFixed(2)) * this.origination.get('taxRate').value),
        interestAmount: 0,
        originalInterestAmount: 0,
        taxAmount: 0,
        taxAmountForDPayment: parseFloat(Math.fround(element.scheduledPaymentAmount).toFixed(2)) * this.origination.get('taxRate').value,
        taxAmountForPayment: 0,
        taxableToState: parseFloat(Math.fround(element.scheduledPaymentAmount).toFixed(2)) * this.origination.get('taxRate').value,
        initial: element.initial,
        lateFee: 0,
        lateFeeOriginal: 0,
        daysLate: 0,
        status: "Unpaid"
      });

      this.scheduledPayments.push(dPmt);
    }
    for (let index = 0; index < schedule.length; index++) {
      const element = schedule[index];
      const pmt = this.fb.group({
        type: "MV Loan",
        number: this.scheduledPayments.length == 0 ? 1 : this.scheduledPayments.length + 1,
        dueDate: element.dueDate,
        scheduledPaymentAmount: element.scheduledPaymentAmount,
        amountDue: element.scheduledPaymentAmount,
        principalPaid: parseFloat(Math.fround(element.principalPaid).toFixed(2)),
        interestAmount: parseFloat(Math.fround(element.interestAmount).toFixed(2)),
        originalInterestAmount: parseFloat(Math.fround(element.interestAmount).toFixed(2)),
        taxAmount: parseFloat(Math.fround(element.taxAmount).toFixed(2)),
        taxAmountForDPayment: 0,
        taxAmountForPayment: parseFloat(Math.fround(element.taxAmountForPayment).toFixed(2)),
        taxableToState: parseFloat(Math.fround(element.taxAmountForPayment).toFixed(2)),
        initial: false,
        lateFee: 0,
        lateFeeOriginal: 0,
        daysLate: 0,
        status: "Unpaid"
      });

      this.scheduledPayments.push(pmt);
    }
  }

  protected addDownPayment() {
    const dPmt = this.fb.group({
      type: ["Down Payment", [Validators.required]],
      number: [this.downPayments.length == 0 ? 1 : this.downPayments.length + 1, [Validators.required]],
      dueDate: [this.origination.get('saleDate').value, [Validators.required]],
      scheduledPaymentAmount: [0, [Validators.required]],
      initial: [false, [Validators.required]],
    });

    this.downPayments.push(dPmt);
  }

  protected buildPayments() {
    this.scheduledPayments.clear();
    this.currentPayoff = this.initialPayoff;
    this.initialUnpaidBalance = this.downPaymentSums ? this.scheduleTotals.totalPrincipalPaid + (this.downPaymentSums['deferred'] || 0) + (this.downPaymentSums['initial'] || 0) : this.scheduleTotals.totalPrincipalPaid;
    this.currentUnpaidBalance = this.initialUnpaidBalance;
    this.buildScheduledPayment(this.schedule);
  }

  protected setDemoTransaction() {
    this.transactions.clear();
    for (let index = 0; index < this.demoTransaction.length; index++) {
      const element = this.demoTransaction[index];
      const trans = this.fb.group({
        amountPaid: element.amountPaid,
        datePaid: element.datePaid,
        principalDue: 0,
        interestDue: 0,
        taxDue: 0,
        taxableToState: 0,
        lateFeesDue: 0,
        transactionId: element.transactionId,
        payoffAfterPayment: 0,
        unpaidPrincipalBalanceAfterPayment: 0,
      });
      this.transactions.push(trans);
    }
  }

  protected buildTransactionBreakdown(transaction) {
    let foundTransactionIndex = -1;
    if (this.transactionBreakdown && this.transactionBreakdown.length > 0) {
      foundTransactionIndex = this.transactionBreakdown.findIndex(
        (res) =>
          res.paymentId == transaction.paymentId &&
          res.transactionId == transaction.transactionId
      );
    }
    if (foundTransactionIndex == -1) {
      let data = {
        id: transaction.id,
        paymentId: transaction.paymentId,
        scheduledPaymentAmount: transaction.scheduledPaymentAmount || 0,
        dueDate: transaction.dueDate,
        principalPaid: transaction.principalPaid || 0,
        interestPaid: transaction.interestPaid || 0,
        taxPaid: transaction.taxPaid || 0,
        transactionId: transaction.transactionId,
        number: this.transactionBreakDownNumber || 0,
        lateFee: transaction.lateFee || 0,
        daysLate: transaction.daysLate || 0,
      };
      this.transactionBreakdown.push(data);
      this.transactionBreakDownNumber = this.transactionBreakDownNumber + 1;
    } else {
      if (transaction.principalPaid) {
        this.transactionBreakdown[foundTransactionIndex].principalPaid =
          transaction.principalPaid;
      }
      if (transaction.taxPaid) {
        this.transactionBreakdown[foundTransactionIndex].taxPaid =
          transaction.taxPaid;
      }
      if (transaction.interestPaid) {
        this.transactionBreakdown[foundTransactionIndex].interestPaid =
          transaction.interestPaid;
      }
      if (transaction.lateFee) {
        let foundPaymentIndex = this.transactionBreakdown.findIndex(
          (res) =>
            res.paymentId == transaction.paymentId
        );
        if (foundPaymentIndex == -1) {
          this.transactionBreakdown[foundPaymentIndex].lateFee =
            transaction.lateFee;
        }
        if (foundPaymentIndex > -1 && (this.transactionBreakdown[foundPaymentIndex].lateFee == 0 || !this.transactionBreakdown[foundPaymentIndex].lateFee)) {
          this.transactionBreakdown[foundTransactionIndex].lateFee =
            transaction.lateFee;
        }
      }
      if (transaction.daysLate) {
        this.transactionBreakdown[foundTransactionIndex].daysLate =
          transaction.daysLate;
      }
    }
  }

  protected sumDownPayments(): void {
    const sum = this.downPayments.controls.length > 0 ? this.downPayments.controls.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue.value.scheduledPaymentAmount),
      0) : 0;

    const deferredDown = this.downPayments.controls.length > 0 ? this.downPayments.controls.filter(res => res.value.initial == false).reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue.value.scheduledPaymentAmount),
      0) : 0;

    this.origination.patchValue({ totalDown: sum })
    this.downPaymentSums = { initial: sum - deferredDown, deferred: deferredDown }
  }

  protected calculatePayments() {
    this.buildPayments();
    this.sumOfPrincipalPaid = 0;
    this.sumOfTaxPaid = 0;
    this.sumOfInterestPaid = 0;
    this.sumOfAmountPaid = 0;
    this.sumOfLateFeesPaid = 0;
    this.sumOfTaxPaidToComptroller = 0;
    for (let index = 0; index < this.transactions.value.length; index++) {
      const transaction = this.transactions.value[index];
      let amtPaid = transaction["amountPaid"];
      this.sumOfAmountPaid += parseFloat(amtPaid)
      let totalToAllocate = amtPaid;
      let datePaid = transaction["datePaid"];
      let allocate = 0
      let taxPaid = 0;
      let taxPaidLine = 0;
      let interestPaid = 0;
      let interestPaidLine = 0;
      let principalPaidLine = 0;
      let principalPaid = 0;
      let totalTaxToAllocate = 0
      let totalTaxPaid = 0
      let taxDueToState = parseFloat(Math.fround((amtPaid) * this.taxRatio).toFixed(2))
      this.sumOfTaxPaidToComptroller = this.sumOfTaxPaidToComptroller + taxDueToState
      this.transactions.controls[index].patchValue({
        taxableToState: parseFloat(Math.fround(taxDueToState).toFixed(2))
      });
      let paymentsDue = this.scheduledPayments.value.filter((res) =>
        parseFloat(Math.fround(res.amountDue).toFixed(2)) > 0
      );

      for (let index2 = 0; index2 < paymentsDue.length; index2++) {
        const scheduledPayment = paymentsDue[index2];
        if (scheduledPayment.amountDue > 0) {
          allocate = parseFloat(Math.fround(scheduledPayment.taxAmountForPayment).toFixed(2)) > parseFloat(Math.fround(totalToAllocate).toFixed(2)) ? parseFloat(Math.fround(totalToAllocate).toFixed(2)) : parseFloat(Math.fround(scheduledPayment.taxAmountForPayment).toFixed(2));
          // if (totalTaxToAllocate > 0) allocate = allocate + totalTaxToAllocate
          if (scheduledPayment.taxAmountForPayment > 0 && moment(scheduledPayment.dueDate).isSameOrBefore(datePaid)) {
            if (allocate >= parseFloat(Math.fround(scheduledPayment.taxAmountForPayment).toFixed(2))) {
              allocate = !scheduledPayment.initial ? parseFloat(Math.fround(allocate).toFixed(2)) - parseFloat(Math.fround(scheduledPayment.taxAmountForPayment).toFixed(2)) : parseFloat(Math.fround(totalToAllocate).toFixed(2));
              taxPaid += parseFloat(Math.fround(scheduledPayment.taxAmountForPayment).toFixed(2));
              taxPaidLine = parseFloat(Math.fround(scheduledPayment.taxAmountForPayment).toFixed(2));
              scheduledPayment.taxAmountForPayment = 0;
            } else {
              scheduledPayment.taxAmountForPayment = parseFloat(Math.fround(scheduledPayment.taxAmountForPayment).toFixed(2)) - parseFloat(Math.fround(allocate).toFixed(2))
              taxPaid += parseFloat(Math.fround(allocate).toFixed(2));
              taxPaidLine = parseFloat(Math.fround(allocate).toFixed(2));
              allocate -= !scheduledPayment.initial ? parseFloat(Math.fround(allocate).toFixed(2)) : 0;
            }
            if (taxPaidLine > 0) {
              scheduledPayment.amountDue -= taxPaidLine;
              this.sumOfTaxPaid = this.sumOfTaxPaid + taxPaidLine;
              this.buildTransactionBreakdown({
                amtPaid,
                transactionId: transaction.transactionId,
                taxPaid: taxPaidLine,
                paymentId: scheduledPayment.number,
                dueDate: scheduledPayment.dueDate,
                scheduledPaymentAmount: scheduledPayment.scheduledPaymentAmount,
                initial: scheduledPayment.initial
              });
              totalToAllocate = !scheduledPayment.initial ? Math.abs(totalToAllocate - taxPaidLine) : totalToAllocate;
              totalTaxToAllocate = allocate - taxPaidLine
            }
            this.transactions.controls[index].patchValue({
              taxDue: parseFloat(Math.fround(taxPaid).toFixed(2))
            });
          }

          // calculate interest allocation
          allocate = parseFloat(Math.fround(scheduledPayment.interestAmount).toFixed(2)) > parseFloat(Math.fround(totalToAllocate).toFixed(2)) ? parseFloat(Math.fround(totalToAllocate).toFixed(2)) : parseFloat(Math.fround(scheduledPayment.interestAmount).toFixed(2))
          if (scheduledPayment.interestAmount > 0 && moment(scheduledPayment.dueDate).isSameOrBefore(datePaid)) {
            this.transactions.controls[index].patchValue({
              interestDue: parseFloat(Math.fround(allocate).toFixed(2)) + parseFloat(Math.fround(interestPaid).toFixed(2)),
            });
            if (allocate >= parseFloat(Math.fround(scheduledPayment.interestAmount).toFixed(2))) {
              allocate = parseFloat(Math.fround(allocate).toFixed(2)) - parseFloat(Math.fround(scheduledPayment.interestAmount).toFixed(2));
              interestPaid += parseFloat(Math.fround(scheduledPayment.interestAmount).toFixed(2));
              interestPaidLine = parseFloat(Math.fround(scheduledPayment.interestAmount).toFixed(2));
              scheduledPayment.interestAmount = 0;
            } else {
              scheduledPayment.interestAmount =
                parseFloat(Math.fround(scheduledPayment.interestAmount).toFixed(2)) - parseFloat(Math.fround(allocate).toFixed(2));
              interestPaid += parseFloat(Math.fround(allocate).toFixed(2));
              interestPaidLine = parseFloat(Math.fround(allocate).toFixed(2));
              allocate -= parseFloat(Math.fround(allocate).toFixed(2));
            }
            if (interestPaidLine > 0) {
              scheduledPayment.amountDue -= interestPaidLine;
              this.sumOfInterestPaid =
                this.sumOfInterestPaid + interestPaidLine;
              this.buildTransactionBreakdown({
                transactionId: transaction.transactionId,
                interestPaid: interestPaidLine,
                paymentId: scheduledPayment.number,
                dueDate: scheduledPayment.dueDate,
                scheduledPaymentAmount: scheduledPayment.scheduledPaymentAmount,
                initial: scheduledPayment.initial
              });
            }
            totalToAllocate = Math.abs(totalToAllocate - interestPaidLine);
          }

          let principalDue =
            amtPaid - taxPaid - interestPaidLine > 0
              ? amtPaid - taxPaid - interestPaidLine
              : 0;
          if (principalDue > this.currentUnpaidBalance) {
            this.currentUnpaidBalance = this.currentUnpaidBalance + (this.scheduleTotals.totalTax - this.sumOfTaxPaid)
            taxPaid = (this.scheduleTotals.totalTax - this.sumOfTaxPaid) + taxPaidLine
            this.transactions.controls[index].patchValue({
              taxDue: parseFloat(Math.fround(taxPaid).toFixed(2))
            });
            this.sumOfTaxPaid = this.sumOfTaxPaid + taxPaid - taxPaidLine;
            let taxDueToStateNow = (this.scheduleTotals.totalTax - this.sumOfTaxPaidToComptroller) + taxDueToState
            this.transactions.controls[index].patchValue({
              taxableToState: parseFloat(Math.fround(taxDueToStateNow).toFixed(2))
            });
            this.sumOfTaxPaidToComptroller = this.sumOfTaxPaidToComptroller + taxDueToStateNow - taxDueToState;
            paymentsDue.forEach(res => {
              res.taxAmountForPayment = 0
              res.principalPaid = 0
              res.amountDue = 0
            });
            principalDue =
              amtPaid - taxPaid - interestPaidLine > 0
                ? amtPaid - taxPaid - interestPaidLine
                : 0;
            this.sumOfPrincipalPaid =
              this.sumOfPrincipalPaid + parseFloat(Math.fround(principalDue).toFixed(2));
          }
          allocate = parseFloat(Math.fround(principalDue).toFixed(2)) > parseFloat(Math.fround(totalToAllocate).toFixed(2)) ? parseFloat(Math.fround(totalToAllocate).toFixed(2)) : parseFloat(Math.fround(principalDue).toFixed(2));

          if (scheduledPayment.principalPaid > 0) {
            this.transactions.controls[index].patchValue({
              principalDue: parseFloat(Math.fround(allocate).toFixed(2)) + parseFloat(Math.fround(principalPaid).toFixed(2))
            });
            if (allocate >= parseFloat(Math.fround(scheduledPayment.principalPaid).toFixed(2))) {
              allocate = parseFloat(Math.fround(allocate).toFixed(2)) - parseFloat(Math.fround(scheduledPayment.principalPaid).toFixed(2));
              principalPaid += parseFloat(Math.fround(scheduledPayment.principalPaid).toFixed(2));
              principalPaidLine = parseFloat(Math.fround(scheduledPayment.principalPaid).toFixed(2));
              scheduledPayment.principalPaid = 0;
            } else {
              scheduledPayment.principalPaid =
                parseFloat(Math.fround(scheduledPayment.principalPaid).toFixed(2)) - parseFloat(Math.fround(allocate).toFixed(2));
              principalPaid += parseFloat(Math.fround(allocate).toFixed(2));
              principalPaidLine = parseFloat(Math.fround(allocate).toFixed(2));
              allocate -= parseFloat(Math.fround(allocate).toFixed(2))
            }
            if (parseFloat(Math.fround(allocate).toFixed(2)) == 0.01) {
              principalPaid += 0.01
              principalPaidLine += parseFloat(Math.fround(scheduledPayment.principalPaid).toFixed(2)) + 0.01
              allocate -= parseFloat(Math.fround(allocate).toFixed(2));
            }
            if (principalPaidLine > 0) {
              scheduledPayment.amountDue -= principalPaidLine;
              this.sumOfPrincipalPaid =
                this.sumOfPrincipalPaid + parseFloat(Math.fround(principalPaidLine).toFixed(2));
              this.buildTransactionBreakdown({
                transactionId: transaction.transactionId,
                principalPaid: principalPaidLine,
                paymentId: scheduledPayment.number,
                dueDate: scheduledPayment.dueDate,
                scheduledPaymentAmount: scheduledPayment.scheduledPaymentAmount,
                initial: scheduledPayment.initial
              });
            }
            totalToAllocate = Math.abs(totalToAllocate - principalPaidLine);
          }
        }
      }

      this.currentPayoff = amtPaid < parseFloat(Math.fround(this.currentPayoff).toFixed(2)) ? this.currentPayoff - principalPaid - taxPaid : 0;
      this.currentUnpaidBalance = parseFloat(Math.fround(this.currentPayoff).toFixed(2)) > 0 ? this.currentUnpaidBalance - principalPaid : 0;
      this.transactions.controls[index].patchValue({
        principalDue: parseFloat(Math.fround(allocate).toFixed(2)) + parseFloat(Math.fround(principalPaid).toFixed(2)),
        payoffAfterPayment: parseFloat(
          Math.fround(this.currentPayoff).toFixed(2)
        ),
        unpaidPrincipalBalanceAfterPayment: parseFloat(Math.fround(this.currentUnpaidBalance).toFixed(3)) <= 0 ? 0 : parseFloat(Math.fround(this.currentUnpaidBalance).toFixed(2)),
        currentUnpaidBalance: parseFloat(Math.fround(this.currentUnpaidBalance).toFixed(3))
      });
    }
  }

  protected chooseEngine() {
    if (this.platform == 'Desktop') {
      this.calculateBuckets()
      return
    }
    if (this.platform == 'API') {
      this.calculateBucketsAPI()
      return
    }

    this.calculatePayments()
  }

  protected calcDue(e: Event, i) {
    let datePaid = (e.target as HTMLInputElement).value
    let amountDue = 0
    let scheduledAmountDue = 0
    let amountPaid = 0


    // what should be due
    let paymentsDue = this.schedule.filter((res) =>
      moment(res.dueDate).isSameOrBefore(datePaid)
    );
    scheduledAmountDue = paymentsDue.length > 0
      ? paymentsDue.reduce(
        (accumulator, currentValue) =>
          accumulator + parseFloat(currentValue.scheduledPaymentAmount),
        0
      )
      : 0;

    // what was paid so far
    let paymentsPaid = this.transactions.value.filter((res) =>
      moment(res.datePaid).isBefore(datePaid)
    );
    amountPaid = paymentsPaid.length > 0
      ? paymentsPaid.reduce(
        (accumulator, currentValue) =>
          accumulator + parseFloat(currentValue.amountPaid),
        0
      )
      : 0;

    // what is due?
    amountDue = scheduledAmountDue - amountPaid
    document.getElementById("amountDue-" + i).innerText = amountDue.toString()
  }

  /**
   * paymentHistoryEngine2
   */
  protected paymentHistoryEngine2(scheduledPayments, paymentFees, receipts) {
    this.lines = []
    let scheduledPaymentsList = null
    let receiptList = receipts
    let lastScheduledPayment = null
    let amountPaid = 0
    let amountDue = 0
    let lateAmountDue = 0

    const getScheduledPaymentNumber = (due) => {
      let index = scheduledPayments.findIndex(res => res.due == due)
      if (index > -1) {
        return scheduledPayments[index].number
      }
    }
    const getScheduledPaymentId = (number) => {
      let index = scheduledPayments.findIndex(res => res.number == number)
      if (index > -1) {
        return scheduledPayments[index].id
      }
    }

    const createLine = (receipt) => {
      if (receipt.refund > 0) {
        return
      }

      let paymentsOnReceipt = receipt.meta
      paymentsOnReceipt.forEach(payment => {
        let scheduledNumber = getScheduledPaymentNumber(payment.due)
        let scheduledId = getScheduledPaymentId(scheduledNumber)
        let daysLate = moment(receipt.paid).diff(payment.due, 'days')
        let paymentsDue = scheduledPayments.filter((res) =>
          moment(res.due).isSameOrBefore(receipt.paid)
        );

        let loanAmountDue =
          paymentsDue.length > 0
            ? paymentsDue.reduce(
              (accumulator, currentValue) =>
                accumulator + parseFloat(currentValue.amount),
              0
            )
            : 0;

        let paymentFeesDue = paymentFees.filter((res) =>
          res.paymentScheduleId == scheduledId
        );

        let paymentFeesAmountUnpaid =
          paymentFeesDue.length > 0
            ? paymentFeesDue.reduce(
              (accumulator, currentValue) =>
                accumulator + parseFloat(currentValue.amount) - parseFloat(currentValue.paid),
              0
            )
            : 0;
        let paymentFeesAmountDue =
          paymentFeesDue.length > 0
            ? paymentFeesDue.reduce(
              (accumulator, currentValue) =>
                accumulator + parseFloat(currentValue.amount),
              0
            )
            : 0;
        let paymentFeesAmountPaid =
          paymentFeesDue.length > 0
            ? paymentFeesDue.reduce(
              (accumulator, currentValue) =>
                accumulator + parseFloat(currentValue.paid),
              0
            )
            : 0;

        let data = {
          receiptNumber: receipt.number,
          datePaid: receipt.paid,
          paymentMethod: receipt.method,
          amountPaid: payment.amount,
          amountUnpaid: 0,
          amountDue: loanAmountDue - amountPaid,
          lateFeeDue: paymentFeesAmountDue,
          lateFeeUnpaid: paymentFeesAmountUnpaid,
          lateFeePaid: paymentFeesAmountPaid,
          totalAmountPaid: receipt.amount,
          totalAmountDue: loanAmountDue + paymentFeesAmountDue,
          dueDate: payment.due,
          number: scheduledNumber,
          category: payment.category,
          daysLate,
          status: daysLate > 16 ? "Late" : "Paid"
        }
        this.lines.push(data)
        lastScheduledPayment = data.number
        amountPaid += payment.amount
        amountDue = loanAmountDue - amountPaid
        lateAmountDue = paymentFeesAmountUnpaid

      });
    }
    receiptList.filter(res => res.refund == 0 && res.termsId == this.paymentParameters.get("term").value)
    receiptList.forEach(receipt => {
      createLine(receipt)
    });
    let paymentFeesAmountDueCum = lateAmountDue || 0
    const createLine2 = (scheduledPayment) => {
      let daysLate = moment(new Date()).diff(scheduledPayment.due, 'days')


      let paymentFeesDue = paymentFees.filter((res) =>
        res.paymentScheduleId == scheduledPayment.id
      );

      let paymentFeesAmountUnpaid =
        paymentFeesDue.length > 0
          ? paymentFeesDue.reduce(
            (accumulator, currentValue) =>
              accumulator + parseFloat(currentValue.amount) - parseFloat(currentValue.paid),
            0
          )
          : 0;
      let paymentFeesAmountDue =
        paymentFeesDue.length > 0
          ? paymentFeesDue.reduce(
            (accumulator, currentValue) =>
              accumulator + parseFloat(currentValue.amount),
            0
          )
          : 0;
      let paymentFeesAmountPaid =
        paymentFeesDue.length > 0
          ? paymentFeesDue.reduce(
            (accumulator, currentValue) =>
              accumulator + parseFloat(currentValue.paid),
            0
          )
          : 0;
      paymentFeesAmountDueCum += paymentFeesAmountUnpaid
      let data = {
        dueDate: scheduledPayment.due,
        number: scheduledPayment.number,
        category: "MV Loan",
        amountDue: amountDue,
        amountPaid: 0,
        amountUnpaid: 0,
        totalAmountDue: amountDue + scheduledPayment.amount + paymentFeesAmountDueCum,
        totalAmountPaid: 0,
        lateFeeDue: paymentFeesAmountDue,
        lateFeeUnpaid: paymentFeesAmountDueCum,
        lateFeePaid: paymentFeesAmountPaid,
        status: daysLate > 1 ? "Missed" : "Future",
        receiptNumber: null,
        datePaid: null,
        paymentMethod: null,
        daysLate: null
      }
      this.lines.push(data)
      amountDue += scheduledPayment.amount
    }

    scheduledPaymentsList = scheduledPayments.filter(res => (res.number > lastScheduledPayment))
    scheduledPaymentsList.forEach(scheduledPayment => {
      createLine2(scheduledPayment)
    });
  }

  protected paymentHistoryEngine3(scheduledPayments, paymentFees, receipts) {
    let paymentMethodSummary = {}
    let paymentHistoryLines = []
    const getScheduledPaymentNumber = (due) => {
      let index = scheduledPayments.findIndex(res => res.due == due)
      if (index > -1) {
        return scheduledPayments[index].number
      }
    }

    const toTitleCase = (str) => {
      return str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(x => x.slice(0, 1).toUpperCase() + x.slice(1))
        .join(' ');
    }

    const insertPaymentMethod = (amountPaid, method) => {
      switch (method) {
        case "Cash": case "cash":
          paymentMethodSummary['cash'] = parseFloat(paymentMethodSummary['cash'] || 0) + parseFloat(amountPaid)
          break;
        case "Check": case "check":
          paymentMethodSummary['check'] = parseFloat(paymentMethodSummary['check'] || 0) + parseFloat(amountPaid)
          break;
        case "Bank Draft": case "bank draft":
          paymentMethodSummary['bankDraft'] = parseFloat(paymentMethodSummary['bankDraft'] || 0) + parseFloat(amountPaid)
          break;
        case "Credit Card": case "credit card":
          paymentMethodSummary['creditCard'] = parseFloat(paymentMethodSummary['creditCard'] || 0) + parseFloat(amountPaid)
          break;
        case "Debit Card": case "debit card":
          paymentMethodSummary['debitCard'] = parseFloat(paymentMethodSummary['debitCard'] || 0) + parseFloat(amountPaid)
          break;
        case "Money Order": case "money order":
          paymentMethodSummary['moneyOrder'] = parseFloat(paymentMethodSummary['moneyOrder'] || 0) + parseFloat(amountPaid)
          break;
        case "Cashiers Check": case "cashiers check":
          paymentMethodSummary['cashiersCheck'] = parseFloat(paymentMethodSummary['cashiersCheck'] || 0) + parseFloat(amountPaid)
          break;
        case "Travelers Check": case "travelers check":
          paymentMethodSummary['travelersCheck'] = parseFloat(paymentMethodSummary['travelersCheck'] || 0) + parseFloat(amountPaid)
          break;
        case "Pre-Paid Debit Card": case "pre-paid debit card":
          paymentMethodSummary['prePaidDebitCard'] = parseFloat(paymentMethodSummary['prePaidDebitCard'] || 0) + parseFloat(amountPaid)
          break;
        case "Third-Party": case "third-party":
          paymentMethodSummary['thirdParty'] = parseFloat(paymentMethodSummary['thirdParty'] || 0) + parseFloat(amountPaid)
          break;
        default:
          paymentMethodSummary['unknown'] = parseFloat(paymentMethodSummary['unknown'] || 0) + parseFloat(amountPaid)
          break;
      }
    }

    const getScheduledPaymentId = (number) => {
      let index = scheduledPayments.findIndex(res => res.number == number)
      if (index > -1) {
        return scheduledPayments[index].id
      }
    }
    const getLoanAmountDue = (paidDate) => {
      let paymentsDue = scheduledPayments.filter((res) =>
        moment(res.due).isSameOrBefore(paidDate)
      );

      let loanAmountDue =
        paymentsDue.length > 0
          ? paymentsDue.reduce(
            (accumulator, currentValue) =>
              accumulator + parseFloat(currentValue.amount),
            0
          )
          : 0;
      return loanAmountDue
    }

    const getLateFeeDue = (scheduledId) => {
      let paymentFeesDue = paymentFees.filter((res) =>
        res.paymentScheduleId == scheduledId
      );
      let paymentFeesAmountDue =
        paymentFeesDue.length > 0
          ? paymentFeesDue.reduce(
            (accumulator, currentValue) =>
              accumulator + parseFloat(currentValue.amount),
            0
          )
          : 0;
      return paymentFeesAmountDue
    }

    const getLateFeeUnpaid = (paidDate) => {
      let paymentFeesDue = paymentFees.filter((res) =>
        moment(res.due).isSameOrBefore(paidDate)
      );

      let paymentFeesAmountUnpaid =
        paymentFeesDue.length > 0
          ? paymentFeesDue.reduce(
            (accumulator, currentValue) =>
              accumulator + parseFloat(currentValue.amount) - parseFloat(currentValue.paid),
            0
          )
          : 0;
      return paymentFeesAmountUnpaid
    }

    const getPaidReceipts = (due) => {
      let receiptPayments = []
      for (let index = 0; index < receipts.length; index++) {
        const receipt = receipts[index];
        for (let index = 0; index < receipt.meta.length; index++) {
          const payment = receipt.meta[index];
          if (payment.due == due) {
            receiptPayments.push({ ...payment, datePaid: receipt.paid, receiptNumber: receipt.number, paymentMethod: receipt.method, amountPaid: receipt.amount })
          }
        }
      }
      return receiptPayments
    }
    const calcStatus = (amountDue, amountPaid, dPaid, dDue) => {
      let status = "Unpaid"
      let remainingAmount = parseFloat(Math.fround(amountDue).toFixed(2)) - parseFloat(Math.fround(amountPaid).toFixed(2))
      if (remainingAmount == 0 || amountPaid > amountDue) {
        status = "Paid"
        if (moment(dPaid).isBefore(dDue)) {
          status = "Prepaid"
        }
      } else {
        status = "Late"
        if (moment(dPaid).isBefore(dDue)) {
          status = "Prepaid"
        }
        if (dPaid == null) {
          if (moment(dDue).isAfter(new Date())) {
            status = "Future"
          }
          else {
            status = "Missed"
          }
        }
      }
      return status
    }
    let totalAmountPaid = 0
    let totalAmountDue = 0
    let totalLoanAmountPaid = 0
    let totalLoanAmountDue = 0
    let lateFeeUnpaid = 0
    let totalLoanAmountUnpaid = 0
    let lastDue = null
    scheduledPayments.forEach(sP => {
      let data = {
        datePaid: null,
        amountDue: sP.amount,
        receiptNumber: null,
        paymentMethod: null,
        number: sP.number,
        dueDate: sP.due,
        amountPaid: 0,
        amountUnpaid: 0,
        lateFeeDue: getLateFeeDue(sP.id),
        lateFeePaid: 0,
        lateFeeUnpaid: 0,
        totalAmountPaid: 0,
        totalAmountDue: totalAmountDue + totalLoanAmountDue,
        status: null
      }
      let loanPayment = getPaidReceipts(sP.due)
      if (loanPayment.length > 0) {
        loanPayment.forEach(receipt => {

          data.datePaid = receipt.datePaid
          data.receiptNumber = receipt.receiptNumber
          data.paymentMethod = receipt.paymentMethod
          data.totalAmountPaid = receipt.amountPaid

          if (receipt.category == 'mv loan') {
            data.amountDue = sP.amount + totalLoanAmountUnpaid
            data.amountPaid = receipt.amount
            data.amountUnpaid = data.amountDue - data.amountPaid
            totalLoanAmountPaid = receipt.amount
            totalLoanAmountDue -= totalLoanAmountPaid
            totalLoanAmountUnpaid = data.amountDue - data.amountPaid
          }
          if (receipt.category == 'late fee') {
            data.lateFeePaid = receipt.amount
          }
          data.status = calcStatus(data.amountDue, data.amountPaid, data.datePaid, data.dueDate)
          lastDue = sP.due
          totalAmountDue -= data.amountPaid
          data.totalAmountDue = data.amountDue + data.lateFeeDue + lateFeeUnpaid
          totalAmountPaid = receipt.amountPaid
        });
      } else {
        data.status = calcStatus(data.amountDue, 0, null, data.dueDate)
        totalLoanAmountDue = data.amountDue - data.amountUnpaid - totalLoanAmountUnpaid
        data.amountDue = sP.number == 1 ? sP.amount : sP.amount + totalLoanAmountUnpaid
        data.amountUnpaid = data.amountDue - data.amountPaid
        totalLoanAmountUnpaid = data.amountUnpaid
        lastDue = sP.due
      }
      data.totalAmountDue = data.amountDue + data.lateFeeDue + lateFeeUnpaid
      lateFeeUnpaid += data.lateFeeDue - data.lateFeePaid
      // totalAmountDue = getLateFeeDue(sP.id) + sP.amount + data.totalAmountDue - totalAmountPaid
      data.lateFeeUnpaid = lateFeeUnpaid
      paymentHistoryLines.push(data)
    })
    this.lines = paymentHistoryLines
  }

  protected paymentHistoryEngine = async (scheduledPayments, actualPayments, paymentFees) => {
    let transactionBreakdown2 = [];
    let transactionBreakDownNumber2 = 1;
    let paymentMethodSummary = {}
    const paymentsActualNoChanges = JSON.stringify(actualPayments)
    const paymentsScheduledNoChanges = JSON.stringify(scheduledPayments)

    const calcStatus = (amountDue, amountPaid, dPaid, dDue) => {
      let status = "Unpaid"
      let remainingAmount = parseFloat(Math.fround(amountDue).toFixed(2)) - parseFloat(Math.fround(amountPaid).toFixed(2))
      if (remainingAmount == 0 || amountPaid > amountDue) {
        status = "Paid"
        if (moment(dPaid).isBefore(dDue)) {
          status = "Prepaid"
        }
      } else {
        status = "Partial"
        if (moment(dPaid).isBefore(dDue)) {
          status = "Prepaid"
        }
      }
      return status
    }

    const getDueLateFees = (scheduledPaymentNumber) => {
      let index = paymentFees.findIndex(res => res.paymentScheduleId == scheduledPaymentNumber && res.category == "Late Fee")
      if (index == -1) {
        return 0
      }
      return parseFloat(paymentFees[index].amount)
    }

    const getLateFeeIndex = (scheduledPaymentNumber) => {
      return paymentFees.findIndex(res => res.paymentScheduleId == scheduledPaymentNumber && res.category == "Late Fee")
    }
    const getScheduledPaymentIndex = (paymentScheduleID) => {
      let index = scheduledPayments.findIndex(res => res.id == paymentScheduleID && res.category == "MV Loan")
      if (index == -1) {
        return 0
      }
      return scheduledPayments[index].number
    }

    const getPaidLateFees = (scheduledPaymentNumber) => {
      let index = paymentFees.findIndex(res => res.paymentScheduleId == scheduledPaymentNumber && res.category == "Late Fee")
      if (index == -1) {
        return 0
      }
      return parseFloat(paymentFees[index].paid)
    }

    const getOutstandingLateFees = (scheduledPaymentNumber) => {
      let index = paymentFees.findIndex(res => res.paymentScheduleId == scheduledPaymentNumber && res.category == "Late Fee")
      if (index == -1) {
        return 0
      }
      let amount = parseFloat(paymentFees[index].amount) - paymentFees[index].paid
      return amount
    }
    const getTotalAmountPaid = (receiptId) => {
      let actualPayments = JSON.parse(paymentsActualNoChanges)
      let payments = actualPayments.filter(res => res.receiptId == receiptId)
      return payments.length > 0
        ? payments.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue['amount']),
          0
        )
        : 0;
    }

    const getTotalAmountDue = (datePaid) => {
      let payments = scheduledPayments.filter(res => moment(res.due).isSameOrBefore(datePaid))
      let loanPayments = payments.length > 0
        ? payments.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue['amount']),
          0
        )
        : 0;
      let paymentsOriginal = JSON.parse(paymentsScheduledNoChanges)
      let paymentsOG = paymentsOriginal.filter(res => moment(res.due).isSameOrBefore(datePaid))
      let loanPaymentsOriginallyDue = paymentsOG.length > 0
        ? paymentsOG.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue['amount']),
          0
        )
        : 0;

      let payments2 = paymentFees.filter(res => moment(res.due).isSameOrBefore(datePaid) && res.category == "Late Fee")
      let latePayments = payments2.length > 0
        ? payments2.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue['amount']),
          0
        )
        : 0;
      let amount = parseFloat(Math.fround(latePayments).toFixed(2)) + parseFloat(Math.fround(loanPayments).toFixed(2)) + (parseFloat(Math.fround(loanPayments).toFixed(2)) == 0 ? loanPaymentsOriginallyDue : 0)
      return amount
    }

    const insertPaymentMethod = (amountPaid, method) => {
      switch (method) {
        case "Cash":
          paymentMethodSummary['cash'] = parseFloat(paymentMethodSummary['cash'] || 0) + parseFloat(amountPaid)
          break;
        case "Check":
          paymentMethodSummary['check'] = parseFloat(paymentMethodSummary['check'] || 0) + parseFloat(amountPaid)
          break;
        case "Bank Draft":
          paymentMethodSummary['bankDraft'] = parseFloat(paymentMethodSummary['bankDraft'] || 0) + parseFloat(amountPaid)
          break;
        case "Credit Card":
          paymentMethodSummary['creditCard'] = parseFloat(paymentMethodSummary['creditCard'] || 0) + parseFloat(amountPaid)
          break;
        case "Debit Card":
          paymentMethodSummary['debitCard'] = parseFloat(paymentMethodSummary['debitCard'] || 0) + parseFloat(amountPaid)
          break;
        case "Money Order":
          paymentMethodSummary['moneyOrder'] = parseFloat(paymentMethodSummary['moneyOrder'] || 0) + parseFloat(amountPaid)
          break;
        case "Cashiers Check":
          paymentMethodSummary['cashiersCheck'] = parseFloat(paymentMethodSummary['cashiersCheck'] || 0) + parseFloat(amountPaid)
          break;
        case "Travelers Check":
          paymentMethodSummary['travelersCheck'] = parseFloat(paymentMethodSummary['travelersCheck'] || 0) + parseFloat(amountPaid)
          break;
        case "Pre-Paid Debit Card":
          paymentMethodSummary['prePaidDebitCard'] = parseFloat(paymentMethodSummary['prePaidDebitCard'] || 0) + parseFloat(amountPaid)
          break;
        case "Third-Party":
          paymentMethodSummary['thirdParty'] = parseFloat(paymentMethodSummary['thirdParty'] || 0) + parseFloat(amountPaid)
          break;
        default:
          paymentMethodSummary['unknown'] = parseFloat(paymentMethodSummary['unknown'] || 0) + parseFloat(amountPaid)
          break;
      }
    }

    const buildLateBreakdown2 = (transaction) => {
      let foundTransactionIndex = -1;
      if (transactionBreakdown2 && transactionBreakdown2.length > 0) {
        foundTransactionIndex = transactionBreakdown2.findIndex(
          (res) =>
            res.number == transaction.number
        );
      }
      if (foundTransactionIndex == -1) {
        let data = {
          number: transaction.number,
          dueDate: transaction.dateDue,
          datePaid: transaction.datePaid,
          lateFeeDue: transaction.lateFeeDue || 0,
          lateFeePaid: transaction.lateFeePaid || 0,
          lateFeeUnpaid: transaction.lateFeeUnpaid || 0,
          increment_number: transactionBreakDownNumber2 || 0,
          category: transaction.category,
          receiptId: transaction.receiptId,
          status: transaction.status,
          transactionId: transaction.transactionId || null,
        };
        transactionBreakdown2.push(data);
        ++transactionBreakDownNumber2
      } else {
        // if (transactionBreakdown2[foundTransactionIndex].datePaid !== null && transactionBreakdown2[foundTransactionIndex].datePaid != transaction.datePaid
        //   || transactionBreakdown2[foundTransactionIndex].transactionId !== null && transactionBreakdown2[foundTransactionIndex].transactionId != transaction.transactionId
        // ) {
        //   let data = {
        //     number: transaction.number,
        //     datePaid: transaction.datePaid,
        //     lateFeeDue: transaction.lateFeeDue || 0,
        //     lateFeePaid: transaction.lateFeePaid || 0,
        //     lateFeeUnpaid: transaction.lateFeeUnpaid || 0,
        //     paymentMethod: transaction.paymentMethod,
        //     receiptId: transaction.receiptId,
        //     overpay: transaction.overpay,
        //     increment_number: transactionBreakDownNumber2 || 0,
        //     status: transaction.status,
        //     dueDate: transactionBreakdown2[foundTransactionIndex].dueDate,
        //     category: transaction.category,
        //     totalAmountPaid: transaction.totalAmountPaid || 0,
        //     totalAmountDue: transaction.totalAmountDue || transaction.amountDue || 0,
        //   };
        //   transactionBreakdown2.push(data);
        //   ++transactionBreakDownNumber2
        // } else {
        if (transaction.amountPaid) {
          transactionBreakdown2[foundTransactionIndex].amountPaid = transaction.amountPaid;
        }
        if (transaction.amountDue) {
          transactionBreakdown2[foundTransactionIndex].amountDue = transaction.amountDue;
        }
        if (transaction.transactionId) {
          transactionBreakdown2[foundTransactionIndex].transactionId = transaction.transactionId;
        }
        if (transaction.status) {
          transactionBreakdown2[foundTransactionIndex].status = transaction.status;
        }
        if (transaction.datePaid) {
          transactionBreakdown2[foundTransactionIndex].datePaid = transaction.datePaid;
        }
        if (transaction.paymentMethod) {
          transactionBreakdown2[foundTransactionIndex].paymentMethod = transaction.paymentMethod;
        }
        if (transaction.receiptId) {
          transactionBreakdown2[foundTransactionIndex].receiptId = transaction.receiptId;
        }
        if (transaction.overpay) {
          transactionBreakdown2[foundTransactionIndex].overpay = transaction.overpay;
        }
        if (transaction.totalAmountPaid) {
          transactionBreakdown2[foundTransactionIndex].totalAmountPaid = transaction.totalAmountPaid;
        }
        if (transaction.totalAmountDue) {
          transactionBreakdown2[foundTransactionIndex].totalAmountDue = transaction.totalAmountDue;
        }
        if (transaction.lateFeeDue) {
          transactionBreakdown2[foundTransactionIndex].lateFeeDue = transaction.lateFeeDue;
        }
        if (transaction.lateFeePaid) {
          transactionBreakdown2[foundTransactionIndex].lateFeePaid = transaction.lateFeePaid;
        }
        if (transaction.lateFeeUnpaid) {
          transactionBreakdown2[foundTransactionIndex].lateFeeUnpaid = transaction.lateFeeUnpaid;
        }
        // }
      }
    }
    const buildPaymentBreakdown2 = (transaction) => {
      let foundTransactionIndex = -1;
      if (transactionBreakdown2 && transactionBreakdown2.length > 0) {
        foundTransactionIndex = transactionBreakdown2.findIndex(
          (res) =>
            res.number == transaction.number
        );
      }
      if (foundTransactionIndex == -1) {
        let data = {
          number: transaction.number,
          dueDate: transaction.dateDue,
          datePaid: transaction.datePaid,
          amountDue: transaction.amountDue || 0,
          increment_number: transactionBreakDownNumber2 || 0,
          category: transaction.category,
          receiptId: transaction.receiptId,
          status: transaction.status,
          transactionId: transaction.transactionId || null,
          totalAmountPaid: transaction.totalAmountPaid || 0,
          totalAmountDue: transaction.totalAmountDue || 0,
        };
        transactionBreakdown2.push(data);
        ++transactionBreakDownNumber2
      } else {
        if (transactionBreakdown2[foundTransactionIndex].datePaid !== null && transactionBreakdown2[foundTransactionIndex].datePaid != transaction.datePaid
          || transactionBreakdown2[foundTransactionIndex].transactionId !== null && transactionBreakdown2[foundTransactionIndex].transactionId != transaction.transactionId
        ) {
          let data = {
            number: transaction.number,
            datePaid: transaction.datePaid,
            amountPaid: transaction.amountPaid,
            paymentMethod: transaction.paymentMethod,
            receiptId: transaction.receiptId,
            overpay: transaction.overpay,
            increment_number: transactionBreakDownNumber2 || 0,
            status: transaction.status,
            dueDate: transactionBreakdown2[foundTransactionIndex].dueDate,
            amountDue: transaction.amountDue,
            category: transactionBreakdown2[foundTransactionIndex].category,
            totalAmountPaid: transaction.totalAmountPaid || 0,
            totalAmountDue: transaction.totalAmountDue || transaction.amountDue || 0,
          };
          transactionBreakdown2.push(data);
          ++transactionBreakDownNumber2
        } else {
          if (transaction.amountPaid) {
            transactionBreakdown2[foundTransactionIndex].amountPaid = transaction.amountPaid;
          }
          if (transaction.amountDue) {
            transactionBreakdown2[foundTransactionIndex].amountDue = transaction.amountDue;
          }
          if (transaction.transactionId) {
            transactionBreakdown2[foundTransactionIndex].transactionId = transaction.transactionId;
          }
          if (transaction.status) {
            transactionBreakdown2[foundTransactionIndex].status = transaction.status;
          }
          if (transaction.datePaid) {
            transactionBreakdown2[foundTransactionIndex].datePaid = transaction.datePaid;
          }
          if (transaction.paymentMethod) {
            transactionBreakdown2[foundTransactionIndex].paymentMethod = transaction.paymentMethod;
          }
          if (transaction.receiptId) {
            transactionBreakdown2[foundTransactionIndex].receiptId = transaction.receiptId;
          }
          if (transaction.overpay) {
            transactionBreakdown2[foundTransactionIndex].overpay = transaction.overpay;
          }
          if (transaction.totalAmountPaid) {
            transactionBreakdown2[foundTransactionIndex].totalAmountPaid = transaction.totalAmountPaid;
          }
          if (transaction.totalAmountDue) {
            transactionBreakdown2[foundTransactionIndex].totalAmountDue = transaction.totalAmountDue;
          }
        }
      }
    }

    let totalAmountDue = 0
    let totalAmountPaid = 0
    let totalAmountRemaining = 0
    let totallateFeeRemaining = 0
    let totallateFeeDue = 0
    let totallateFeePaid = 0
    let amountPaid = 0
    let latePaid = 0
    let totalPaymentAmount = 0
    let totalPaymentDue = 0
    let receiptId = 0
    let actualLoanPayments = actualPayments.filter(res => res.category == "MV Loan")
    let actualLateFeePayments = actualPayments.filter(res => res.category == "Late Fee")
    let latePaymentFees = paymentFees.filter(res => res.category == "Late Fee")
    for (let index = 0; index < scheduledPayments.length; index++) {
      const scheduledPayment = scheduledPayments[index];
      let dateDue = moment(scheduledPayment["due"]).format("YYYY-MM-DD");
      let amountDue = parseFloat(scheduledPayment.amount);
      if (amountDue > 0) {
        totalAmountDue = totalAmountDue + amountDue
        let totalActualPaymentAmountPaid = actualLoanPayments.length > 0
          ? actualLoanPayments.reduce(
            (accumulator, currentValue) =>
              accumulator + parseFloat(currentValue.amount),
            0
          )
          : 0;
        let initialTransaction = {
          number: scheduledPayment.number == 0 ? scheduledPayment.number + 1 : scheduledPayment.number,
          category: scheduledPayment.category,
          dateDue,
          datePaid: null,
          amountDue: amountDue,
          status: moment().isSameOrBefore(dateDue) ? "Future" : "Missed",
        }
        buildPaymentBreakdown2(initialTransaction)
        let index2 = 0;
        do {
          const actualPayment = actualLoanPayments[index2];
          amountPaid = 0
          latePaid = 0

          if (actualPayment && parseFloat(actualPayment.amount) > 0) {
            if (actualPayment.receiptId != receiptId) {
              totalPaymentAmount = getTotalAmountPaid(actualPayment.receiptId)
              totalPaymentDue = getTotalAmountDue(actualPayment.received)
            }
            if (actualPayment.category == "MV Loan") {
              if (actualPayment.amount >= amountDue) {
                scheduledPayment.amount = 0
                actualPayment.amount = parseFloat(actualPayment.amount) - amountDue
                amountPaid = amountDue
              } else {
                scheduledPayment.amount = parseFloat(scheduledPayment.amount) - parseFloat(actualPayment.amount)
                amountPaid = actualPayment.amount
                actualPayment.amount = 0
              }
              insertPaymentMethod(amountPaid, actualPayment.method)
              totalAmountPaid = parseFloat(totalAmountPaid.toString()) + parseFloat(amountPaid.toString())
              let transaction = {
                number: scheduledPayment.number == 0 ? scheduledPayment.number + 1 : scheduledPayment.number,
                transactionId: actualPayment.id,
                amountPaid,
                datePaid: moment(actualPayment.received).format("YYYY-MM-DD"),
                paymentMethod: actualPayment.method,
                receiptId: actualPayment.receiptId,
                overpay: amountDue < actualPayment.amount ? true : false,
                amountDue: amountDue,
                totalAmountPaid: totalPaymentAmount,
                totalAmountDue: totalPaymentDue,
                status: calcStatus(totalAmountRemaining, amountPaid, moment(actualPayment.received).format("YYYY-MM-DD"), moment(dateDue).format("YYYY-MM-DD"))
              }
              if (parseFloat(Math.fround(transaction.amountDue).toFixed(2)) > 0 && parseFloat(Math.fround(transaction.amountPaid).toFixed(2))) {
                buildPaymentBreakdown2(transaction)
              }
              amountDue = parseFloat(Math.fround(amountDue).toFixed(2)) - parseFloat(Math.fround(amountPaid).toFixed(2))
            }
            receiptId = actualPayment.receiptId
          }
          totalAmountRemaining = totalAmountDue - totalAmountPaid
          ++index2
          // if (index2 == 100) {
          //   alert()
          // }
        } while (totalAmountRemaining > 0 && index2 < actualLoanPayments.length);
        if (parseFloat(Math.fround(totalAmountRemaining).toFixed(2)) > 0) {
          let dueAmount = totalActualPaymentAmountPaid == 0 && totalAmountRemaining == 0 ? amountDue : totalAmountRemaining
          let trans = {
            number: scheduledPayment.number == 0 ? scheduledPayment.number + 1 : scheduledPayment.number,
            category: scheduledPayment.category,
            amountDue: dueAmount,
            status: moment().isSameOrBefore(dateDue) ? "Future" : "Missed",
          }
          buildPaymentBreakdown2(trans)
        }
      }
    }
    for (let index = 0; index < latePaymentFees.length; index++) {
      const paymentFee = latePaymentFees[index];
      let dateDue = paymentFee.due
      let paidAmount = paymentFee.paid
      let amount = paymentFee.amount
      let amountDue = amount - paidAmount

      let initialTransaction = {
        number: getScheduledPaymentIndex(paymentFee.paymentScheduleId),
        category: "Late Fee",
        dateDue,
        datePaid: null,
        lateFeeDue: amount,
        status: moment().isSameOrBefore(dateDue) ? "Future" : "Missed",
      }
      buildLateBreakdown2(initialTransaction)

    }

    let transactionBreakdown2Sorted = transactionBreakdown2.sort(function (firstItem, secondItem) { return Date.parse(firstItem.datePaid) - Date.parse(secondItem.datePaid) })
    this.transactionBreakdown2 = transactionBreakdown2Sorted

    return { transactionBreakdown2 }
  }

  protected getPayments() {
    let payload = { ...this.paymentParameters.getRawValue() }
    this.master.get(`buildPaymentHistory?dealer=${payload.dealer}&lot=${payload.lot}&term=${payload.term}&contact=${payload.contact}`, res => {
      if (!res) {
        this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
        return
      }
      if (res.status !== 200) {
        this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
        return
      }

      this.realScheduledPayments = res.data.result.realScheduledPayments
      this.realActualPayments = res.data.result.realActualPayments
      this.realPaymentFees = res.data.result.realPaymentFees
      this.transactionBreakdown2 = res.data.result.transactionBreakdown2
      this.updatedPaymentSchedule = res.data.result.paymentsDue
      this.updatedPaymentSchedule = res.data.result.receipts

      // this.paymentHistoryEngine(this.realScheduledPayments, this.realActualPayments, this.realPaymentFees)
      this.paymentHistoryEngine3(this.realScheduledPayments, this.realPaymentFees, res.data.result.receipts)
    })
  }
}